import React from 'react';
import { useIntl } from 'react-intl';
import { Evidence, useDictionaryEvidence } from '@eas/common-web';
import { ExportTags } from '../../../common/export-tags';
import { Program } from '../../../common/models';
import { initNewDisabledItem } from '../../../utils/dictionary-item';
import { useValidationSchema } from './programs-schema';

export function OperatorPrograms() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();

  const evidence = useDictionaryEvidence<Program>({
    identifier: 'PROGRAMS',
    apiProps: {
      url: '/api/ks/programs',
    },
    tableProps: {
      tableName: intl.formatMessage({
        id: 'KS_O_PROGRAMS_TABLE_TITLE',
        defaultMessage: 'Programy',
      }),
      reportTag: ExportTags.PROGRAM_GRID,
    },
    detailProps: {
      validationSchema,
      initNewItem: initNewDisabledItem,
    },
  });

  return <Evidence {...evidence} />;
}
